import { parseUTCDate } from '@/lib/utils'
import type { WithoutProjectGroup } from '@/components/action-items-table'
import type { components } from '@/api/schema'

type Project = components['schemas']['InternalProjectWithActionsRead']
type ProjectAction = components['schemas']['ProjectOpenActionRead']

/** Where the "No project" group goes among the projects: first, or, for closed items, by its latest closed one. */
export function withoutProjectPlace(items: Project[], group: WithoutProjectGroup | undefined, resolved: boolean) {
  if (!resolved || !group) return 0
  const latest = (actions: ProjectAction[]) =>
    Math.max(0, ...actions.map((action) => (action.resolved_at ? parseUTCDate(action.resolved_at).getTime() : 0)))
  const groupLatest = latest(group.actions)
  const place = items.findIndex((project) => latest(project.actions ?? []) < groupLatest)
  return place === -1 ? items.length : place
}
